import { render, staticRenderFns } from "./HolidaysOverview.vue?vue&type=template&id=534e61e4&scoped=true&"
import script from "./HolidaysOverview.vue?vue&type=script&lang=js&"
export * from "./HolidaysOverview.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysOverview.vue?vue&type=style&index=0&id=534e61e4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e61e4",
  null
  
)

export default component.exports